import { render } from "./SidebarByteRivo.vue?vue&type=template&id=0122a04a&scoped=true"
import script from "./SidebarByteRivo.vue?vue&type=script&lang=js"
export * from "./SidebarByteRivo.vue?vue&type=script&lang=js"

import "./SidebarByteRivo.vue?vue&type=style&index=0&id=0122a04a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0122a04a"]])

export default __exports__